module.exports = "<json-editor style=\"min-height: 400px;\" [options]=\"editorOptions\" [data]=\"data\" (change)=\"GetData($event)\">\n</json-editor>"